import * as types from "./mutation_types";

export default {
  [types.STRUCTURE_RESET](state) {
    Object.assign(state, {
      error: "",
      isLoading: false,
      items: null,
      previous: null,
      next: null,
    });
  },

  [types.STRUCTURE_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.STRUCTURE_SET_ITEMS](state, items) {
    Object.assign(state, { items });
  },

  [types.STRUCTURE_TOGGLE_LOADING](state) {
    Object.assign(state, { isLoading: !state.isLoading });
  },
};
